import template from './accountDetails.template.html';

export default {
  template,
  bindings: {
    account: '<',
    organization: '<',
    countries: '<',
    onFinished: '&'
  },
  controller: class controller {
    constructor($rootScope, $mdMedia, helperService, PersonalTitle, Address) {
      'ngInject';

      const ctrl = this;
      ctrl.mdMedia = $mdMedia;
      ctrl.organizationCountry = null;
      ctrl.currentDateFormat = null;
      ctrl.currentCurrency = null;
      ctrl.availablePersonalTitles = [];
      ctrl.availableStates = [];
      ctrl.availableStreetTypes = [];
      ctrl.alias = null;
      ctrl.isAlias = false;
      ctrl.isReady = false;

      ctrl.initialize = () => {
        ctrl.organizationCountry = helperService.getOrganizationCountry();
        ctrl.currentDateFormat = $rootScope.CurrentDateFormatPrimary();
        ctrl.currentCurrency = $rootScope.CurrentCurrency();
        ctrl.availablePersonalTitles = PersonalTitle.available();
        ctrl.availableStates = helperService.getAvailableAddressStates();
        ctrl.availableStreetTypes = helperService.getAvailableAddressStreetTypes();
        ctrl.account = ctrl.account || {};
        ctrl.organization = ctrl.organization || {};
        ctrl.countries = ctrl.countries || [];
        if (_.isEmpty(ctrl.account?.user?.address)) {
          ctrl.account.user.address = Address.blank();
        }
        if (_.isEmpty(ctrl.account?.user?.title)) {
          ctrl.account.user.title = PersonalTitle.none;
        }
        if (
          ctrl.account?.exchange?.alias &&
          ctrl.account?.exchange?.alias[ctrl.organization.id]
        ) {
          ctrl.isAlias = true;
          ctrl.alias = ctrl.account.exchange.alias[ctrl.organization.id];
        }
        ctrl.isReady = true;
      };

      ctrl.toggleAlias = () => {
        if (ctrl.alias) {
          ctrl.alias = null;
        } else {
          ctrl.alias = { ...ctrl.account?.exchange?.eMail };
        }
        ctrl.account.exchange.alias = ctrl.account?.exchange?.alias || {};
        ctrl.account.exchange.alias[ctrl.organization.id] = ctrl.alias;
        ctrl.saveAccount();
      };

      ctrl.saveAccount = () => {
        const country = _.find(
          ctrl.countries || [],
          (c) => c?.cca2?.toLowerCase() === ctrl.account?.user?.location?.toLowerCase()
        );

        if (
          ctrl.account?.user?.address?.country?.toLowerCase() !==
          country?.name?.common?.toLowerCase()
        ) {
          const newCountry = _.find(
            ctrl.countries || [],
            (c) =>
              c?.name?.common?.toLowerCase() ===
              ctrl.account?.user?.address?.country?.toLowerCase()
          );
          if (newCountry?.cca2) {
            ctrl.account.user.location = newCountry?.cca2;
          }
          if (newCountry?.callingCode[0]) {
            const callingCode = newCountry.callingCode[0];
            ctrl.account.user.prefix = callingCode;
            ctrl.account.user.fixedPrefix = callingCode;
          }
        }

        const data = {
          id: ctrl.account?.id,
          user: ctrl.account?.user || {},
          exchange: ctrl.account?.exchange || {}
        };
        ctrl.onFinished({ data });
      };

      ctrl.$onInit = () => {
        ctrl.initialize();
      };
    }
  }
};
